var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1094,
    height: 1094,
    viewBox: "0 0 1094 1094",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M668.817 395.426C676.803 393.621 683.258 392.09 687.415 390.886C676.092 377.758 671.552 371.194 664.167 361.84C664.167 361.84 665.644 372.015 668.762 395.317L668.817 395.426ZM674.287 436.232V436.725C682.328 492.847 691.736 554.877 692.393 566.965L477.64 566.583C478.352 527.964 494.05 419.822 503.076 364.193C498.317 366.162 414.571 397.013 404.616 386.893V386.62C397.669 346.798 388.753 303.366 383.666 270.656L407.187 260.427C410.852 271.859 426.824 313.704 436.834 335.639C459.275 314.982 483.782 296.688 509.968 281.049C526.378 272.187 553.181 273.281 553.181 273.281C553.524 270.763 554.482 268.367 555.97 266.307C557.458 264.246 559.431 262.583 561.714 261.466L563.301 260.864C581.625 255.832 615.211 259.442 619.423 262.013C622.95 264.742 625.424 268.607 626.424 272.953C626.424 272.953 671.114 279.517 684.242 290.293C684.242 290.293 724.064 344.719 743.975 387.44C751.305 403.139 748.515 412.766 735.168 420.26C727.51 425.402 701.254 431.528 674.396 436.232H674.287ZM600.168 414.352C601.153 411.727 595.081 404.342 587.916 403.741H587.205L589.94 380.329C589.94 377.43 579 374.859 565.817 374.859C552.634 374.859 541.749 377.266 541.749 380.329C541.757 380.666 541.872 380.992 542.077 381.259L545.031 407.241C545.006 407.386 545.006 407.534 545.031 407.679C544.242 407.628 543.452 407.749 542.714 408.033C541.976 408.317 541.309 408.758 540.758 409.324C540.207 409.891 539.785 410.57 539.522 411.316C539.259 412.061 539.16 412.854 539.233 413.641C539.506 415.482 540.214 417.232 541.298 418.744C542.383 420.257 543.812 421.489 545.468 422.339C544.742 422.178 543.99 422.179 543.264 422.341C542.538 422.502 541.856 422.821 541.267 423.275C540.677 423.729 540.195 424.306 539.853 424.967C539.511 425.627 539.318 426.354 539.287 427.098C539.636 428.757 540.367 430.313 541.421 431.642C542.474 432.971 543.823 434.037 545.359 434.756C544.689 434.534 543.977 434.472 543.279 434.574C542.581 434.676 541.916 434.939 541.338 435.342C540.759 435.746 540.282 436.278 539.945 436.898C539.608 437.518 539.421 438.208 539.397 438.913C539.397 441.538 543.116 444.82 549.79 447.118V448.431L551.431 463.145C555.999 464.48 560.729 465.18 565.489 465.223C570.674 465.117 575.831 464.419 580.859 463.145L582.391 449.251V448.376C589.277 447.12 596.021 445.178 602.521 442.578L603.45 441.812C598.582 436.944 595.081 421.19 600.278 414.352H600.168Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M562.207 989.632V989.304H473.647C471.076 974.754 481.907 968.354 493.339 967.041C517.134 964.252 545.687 949.1 550.118 948.17H598.91C598.91 956.594 598.91 961.735 598.91 962.775V963.431C593.336 965.136 587.627 966.362 581.844 967.096C570.412 968.573 559.526 974.973 562.207 989.632Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M562.207 989.304V989.632C559.526 974.973 570.412 968.573 581.844 967.26C587.627 966.526 593.336 965.3 598.91 963.595C617.672 958.125 635.231 949.1 638.622 948.389H688.673C688.673 970.761 688.399 985.585 688.673 989.414L562.207 989.304Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M585.837 162.295C586.437 162.337 586.996 162.613 587.395 163.063C587.794 163.513 588 164.101 587.97 164.702C587.915 165.306 587.627 165.866 587.169 166.263C586.71 166.661 586.115 166.866 585.509 166.835C584.909 166.779 584.355 166.49 583.966 166.03C583.577 165.569 583.385 164.974 583.43 164.373C583.444 164.076 583.517 163.785 583.647 163.517C583.777 163.249 583.961 163.01 584.186 162.816C584.411 162.621 584.674 162.475 584.958 162.385C585.242 162.296 585.541 162.265 585.837 162.295Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M555.807 161.474C556.35 161.589 556.833 161.897 557.166 162.341C557.5 162.784 557.662 163.334 557.622 163.888C557.582 164.441 557.343 164.962 556.949 165.353C556.555 165.744 556.032 165.979 555.479 166.015C555.151 166.036 554.823 165.986 554.516 165.87C554.209 165.754 553.931 165.573 553.7 165.34C553.469 165.107 553.29 164.828 553.176 164.52C553.062 164.212 553.015 163.884 553.039 163.556C553.063 163.229 553.156 162.911 553.313 162.622C553.47 162.334 553.687 162.083 553.949 161.886C554.212 161.689 554.513 161.55 554.833 161.479C555.154 161.408 555.486 161.406 555.807 161.474Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M503.24 364.357C498.481 366.326 414.735 397.177 404.78 387.057",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M615.649 144.025C614.992 139.43 614.281 134.07 613.242 128.6C611.964 119.656 608.466 111.175 603.068 103.93C590.541 89.9268 577.085 95.178 565.653 106.938C562.372 110.337 559.372 113.996 556.682 117.878C548.503 129.589 542.209 142.509 538.029 156.168C533.216 175.095 559.909 217.761 567.622 220.824C568.546 221.162 569.498 221.418 570.466 221.59C581.735 223.723 596.066 213.658 600.88 203.757",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M619.532 262.177C619.532 229.795 621.283 200.366 618.602 168.093",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M570.74 220.167C570.714 220.605 570.714 221.043 570.74 221.48C567.895 234.225 567.13 249.979 561.878 261.302",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M611.163 149.769C612.514 147.769 614.093 145.934 615.867 144.299C628.667 133.359 637.146 157.7 631.894 164.592C630.237 166.335 628.099 167.546 625.752 168.072C623.405 168.597 620.955 168.415 618.712 167.546C617.682 167.265 616.691 166.861 615.758 166.343",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M556.791 117.769C553.728 117.441 511.226 108.853 517.298 96.9284C520.799 90.1456 543.335 97.366 565.762 106.665C587.095 115.526 608.428 126.248 613.351 128.545L614.117 128.873",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M581.516 152.175C583.75 151.488 586.117 151.342 588.419 151.751C590.721 152.16 592.892 153.112 594.753 154.528",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M618.11 154.199C620.461 156.308 623.486 157.51 626.643 157.591",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M551.814 153.16C555.424 151.519 563.574 151.957 565.051 155.512C567.403 161.256 563.902 173.18 562.425 180.018C561.386 184.667 559.745 193.693 567.895 191.286",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M579.109 202.773C578.136 203.822 576.941 204.64 575.61 205.167C574.28 205.693 572.848 205.915 571.421 205.815C569.993 205.716 568.607 205.297 567.362 204.591C566.118 203.884 565.048 202.908 564.231 201.734",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M600.223 815.796C599.731 874.106 599.02 924.43 598.801 948.334C598.801 956.758 598.801 961.899 598.801 962.939",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M654.65 584.032C653.993 607.443 670.02 621.556 690.041 627.3C695.782 628.933 701.692 629.905 707.654 630.199",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M688.454 989.304C688.454 985.475 688.454 970.651 688.454 948.279C689.056 880.178 690.423 741.623 689.822 627.3C689.822 606.951 689.548 587.369 689.275 569.099",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M562.207 989.632L688.454 990.179C688.454 990.179 688.454 989.797 688.454 989.414",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M569.755 611.655C572.761 680.579 583.066 748.99 600.497 815.741C612.038 862.236 625.44 906.707 638.349 947.732V948.279C634.958 948.99 617.399 958.07 598.637 963.486C593.063 965.191 587.353 966.417 581.57 967.151C570.138 968.463 559.253 974.863 561.933 989.523",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M481.962 567.239C485.353 718.156 518.392 847.85 550.008 948.279C545.578 949.209 517.188 964.361 493.23 967.151C481.798 968.464 470.967 974.863 473.538 989.414H563.41",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M547.985 948.334H550.008H597.98",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M638.568 948.334H638.623H688.564",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M688.454 990.179V999.697H562.207V989.632V989.359H688.454V989.414V990.179Z",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M562.042 989.632V999.697H473.647V989.523V989.359H562.042V989.632Z",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M674.506 436.725C682.547 492.847 691.955 554.877 692.611 566.966L477.859 566.583C478.57 527.964 494.269 419.823 503.295 364.193C503.295 362.606 503.787 361.129 504.006 359.652",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M435.139 337.608L436.834 336.077C459.254 315.267 483.762 296.826 509.968 281.049C526.378 272.187 553.181 273.281 553.181 273.281C553.524 270.763 554.482 268.367 555.97 266.307C557.458 264.246 559.431 262.583 561.714 261.466L563.301 260.864C581.625 255.832 615.211 259.442 619.423 262.013C622.95 264.742 625.424 268.607 626.424 272.953C626.424 272.953 671.114 279.517 684.242 290.293C684.242 290.293 724.064 344.719 743.975 387.44C751.304 403.139 748.515 412.766 735.168 420.26C727.127 424.855 701.145 431.2 674.287 435.686C642.616 441.156 609.796 444.985 604.326 442.085C603.838 441.83 603.395 441.497 603.013 441.101C598.473 436.397 594.972 420.698 600.168 413.751C601.214 412.382 602.671 411.385 604.326 410.906C627.245 404.288 651.477 398.818 668.708 394.825C676.694 393.02 683.148 391.488 687.306 390.284C675.983 377.156 671.443 370.593 664.058 361.239C664.058 361.239 665.535 371.413 668.653 394.715",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M586.603 409.375C583.321 417.853 566.966 416.376 559.8 415.228C557.284 414.845 547 411.891 545.195 407.296C545.17 407.151 545.17 407.003 545.195 406.859",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M545.25 407.351C544.461 407.3 543.67 407.421 542.933 407.705C542.195 407.989 541.528 408.429 540.977 408.996C540.426 409.563 540.004 410.242 539.741 410.987C539.477 411.733 539.379 412.526 539.451 413.313C539.725 415.154 540.433 416.904 541.517 418.416C542.602 419.929 544.031 421.161 545.687 422.01C553.53 426.572 562.738 428.2 571.67 426.605",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M545.578 422.065C544.852 421.905 544.099 421.905 543.373 422.067C542.647 422.229 541.965 422.548 541.376 423.002C540.787 423.455 540.304 424.033 539.962 424.693C539.62 425.354 539.427 426.081 539.397 426.824C539.746 428.484 540.476 430.04 541.53 431.369C542.584 432.698 543.932 433.764 545.468 434.482C553.331 438.528 562.279 439.965 571.013 438.585",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M545.359 434.591C544.689 434.37 543.977 434.308 543.279 434.41C542.581 434.511 541.916 434.775 541.337 435.178C540.759 435.582 540.282 436.114 539.945 436.734C539.608 437.354 539.421 438.044 539.397 438.749C539.397 441.374 543.116 444.656 549.79 446.954C560.275 450.054 571.368 450.487 582.063 448.212C588.949 446.956 595.693 445.013 602.192 442.414",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M600.168 414.243C601.153 411.618 595.081 404.233 587.916 403.631",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M541.968 380.001L542.077 380.931L545.031 406.913L545.085 407.241",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M589.994 380.001L589.939 380.165L587.204 403.577L586.548 409.429",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M542.077 380.931C541.872 380.664 541.757 380.338 541.749 380.001C541.749 377.102 552.689 374.531 565.817 374.531C578.945 374.531 589.94 376.938 589.94 380.001C589.611 382.845 579 385.143 565.872 385.143C553.892 385.307 543.992 383.392 542.077 380.931Z",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M582.227 449.087L580.695 462.981C575.667 464.255 570.51 464.953 565.324 465.059C560.565 465.016 555.835 464.316 551.267 462.981L549.626 448.266",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M407.46 259.551C416.759 246.041 408.937 223.285 406.312 214.26C404.78 208.79 396.848 209.227 397.669 216.995C398.325 223.668 399.255 230.725 396.52 233.405",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M396.137 234.28C396.162 234.135 396.162 233.987 396.137 233.843V233.843C390.832 218.8 373.601 191.45 364.685 196.92C363.887 197.341 363.279 198.051 362.984 198.904C362.689 199.757 362.73 200.691 363.099 201.515C364.119 203.759 365.59 205.77 367.42 207.422C373.182 212.495 377.678 218.846 380.548 225.966",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M362.825 201.679C361.852 200.402 360.592 199.371 359.149 198.668C357.705 197.965 356.116 197.61 354.511 197.631C353.431 197.571 352.365 197.903 351.511 198.567C350.657 199.23 350.071 200.18 349.861 201.241C348.986 203.976 350.901 206.164 352.815 207.969C359.831 215.064 365.916 223.023 370.921 231.654",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M382.9 270.874C375.242 269.999 369.28 252.222 367.256 246.369C363.833 237.837 358.863 230.011 352.596 223.285C350.299 220.605 345.595 216.174 345.868 212.345C346.049 211.616 346.378 210.932 346.835 210.336C347.292 209.74 347.867 209.244 348.524 208.88C349.181 208.515 349.905 208.29 350.653 208.218C351.401 208.146 352.155 208.229 352.87 208.462",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M385.416 244.29C383.228 237.07 392.035 234.061 396.356 234.225",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M404.342 386.784C397.396 346.962 388.479 303.53 383.392 270.82L406.913 260.591C410.578 272.023 426.551 313.869 436.561 335.803",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M572.217 367.42C573.607 365.977 574.676 364.256 575.355 362.371C576.034 360.485 576.306 358.478 576.155 356.48C574.827 353.37 573.254 350.37 571.451 347.509C568.005 339.632 571.451 333.889 576.921 328.473",
    stroke: "white",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M558.378 367.42C559.768 365.977 560.837 364.256 561.516 362.371C562.195 360.485 562.467 358.478 562.316 356.48C560.966 353.38 559.393 350.382 557.612 347.509C554.111 339.632 557.612 333.889 563.082 328.473",
    stroke: "white",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M636.653 948.334C629.05 951.288 603.833 964.087 581.953 966.658C570.466 967.971 562.097 972.128 562.316 990.562",
    stroke: "white",
    strokeWidth: 0.86,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M596.996 412.493C617.454 401.553 651.696 395.481 669.309 391.269",
    stroke: "white",
    strokeWidth: 0.86,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M678.28 439.569L674.013 440.335C641.74 445.805 605.967 445.805 597.433 441.593",
    stroke: "white",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuy);
export default __webpack_public_path__ + "static/media/guy.6d5762d138e463429a73987e73c3bb30.svg";
export { ForwardRef as ReactComponent };